export const linkClassNames = [
  'border-1 border-puma-silver rounded-lg',
  'hover:border-white hover:rounded-lg',
  'focus:border-white focus:ring-2 focus:ring-gray-50 focus:rounded-lg',
];
